import * as React from 'react'
import { Box, Typography } from '@mui/material'

import { NotAllowedBlock } from '@components'
import { ellipsisLined } from '@utils'


export default function lastReviewColumn() {
	return {
		name: "lastReview", label: "Last Review",
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', alignItems: 'center'}}>
				{!!value && <Typography sx={ellipsisLined({ lines: 3, maxWidth: 225 })}>
					{value}
				</Typography>}

				{!value && <NotAllowedBlock />}
			</Box> 
		}
	}
}